// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1yv7YVGAyfPdXX5GXCSINJ {\n  width: 100%;\n}\n\n._1G8YUW7nDC5lX4151hkevd {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n._3-e9IefWOGgAFLZokPcePt .Select-aria-only {\n  float: right !important;\n  width: 100%;\n  flex: 1;\n}\n\n._2yntm0rxWY9IuUwYU0r9Sx {\n  border-radius: 3px;\n  border: 1px solid #87CEFA;\n  background: rgba(135, 206, 250, 0.05);\n  margin: 2px 0;\n  padding: 0.5em;\n}\n\n._1kgVcTLTLSt9AZg9vCYXz8 {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n._1kgVcTLTLSt9AZg9vCYXz8 > * {\n  margin: 2px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_1yv7YVGAyfPdXX5GXCSINJ",
	"option": "_1G8YUW7nDC5lX4151hkevd",
	"inputContainer": "_3-e9IefWOGgAFLZokPcePt",
	"display": "_2yntm0rxWY9IuUwYU0r9Sx",
	"optionsContainer": "_1kgVcTLTLSt9AZg9vCYXz8"
};
module.exports = exports;
